import cn from 'classnames'
import { useSnapshot } from 'valtio'
import { type ReactElement } from 'react'
import { proxyGlobalAuth } from '../../../../../shared/proxies/proxyGlobalAuth'

interface ButtonProps {
  additionalClasses?: string
  isSkipped?: boolean
  clickFunction: (event: React.MouseEvent<HTMLButtonElement>) => void
}

function SkipResumeButton ({ additionalClasses, clickFunction, isSkipped }: ButtonProps): ReactElement {
  const { siteTheme: { addEntityButton } } = useSnapshot(proxyGlobalAuth)

  return (
    <button
      onClick={clickFunction}
      type="button"
      className={cn(addEntityButton.classes, additionalClasses, 'flex font-medium items-center justify-center rounded-lg bg-white ')}
    >
      {isSkipped ? 'Resume' : 'Skip'}
    </button>
  )
}

export default SkipResumeButton
